export const enum UserInfoPerspective {
    OrganizationPerspective = 0,
    ApplicationPerspective = 1
}
